import { render, staticRenderFns } from "./IndicatorItemsSelect.vue?vue&type=template&id=13cb6660"
import script from "./IndicatorItemsSelect.vue?vue&type=script&lang=js"
export * from "./IndicatorItemsSelect.vue?vue&type=script&lang=js"
import style0 from "./IndicatorItemsSelect.vue?vue&type=style&index=0&id=13cb6660&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports